import { useState, useEffect } from 'react'
import { FiEdit2 } from 'react-icons/fi'

import api from '../../../utils/api'
import Modal from '../../../shared/modal/Modal'
import NewPurchaseOrder from './NewPurchaseOrder'

import './PurchaseOrder.css'

function statusBadgeClass(status) {
    if (status === 'recebido') return 'pol-status-badge-recebido'
    if (status === 'cancelado') return 'pol-status-badge-cancelado'
    return ''
}

function statusLabel(status) {
    if (status === 'recebido') return 'Recebido'
    if (status === 'cancelado') return 'Cancelado'
    return 'Aguardando'
}

function PurchaseOrderList({ order, myPermissionEdit, myPermissionProviderCreate, handleOnChange }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const [purchaseOrders, setPurchaseOrders] = useState([])
    const [load, setLoad] = useState(false)
    const [editItem, setEditItem] = useState(null)

    function getAll() {
        api.get(`/purchase/order/getByOrder/${order._id}`, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            setPurchaseOrders(response.data.purchaseOrders || [])
            setLoad(true)
        })
    }

    useEffect(() => {
        getAll()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!load) {
        return <div className="pg-loading">Carregando pedidos de compra...</div>
    }

    return (
        <div className="pol">
            <div className="pol-header">
                <p className="pol-title">Pedidos de Compra — #{order.code}</p>
                <span className="pol-title-accent" />
            </div>

            <div className="pol-list">
                {purchaseOrders.length > 0 ? (
                    purchaseOrders.map((po) => (
                        <div key={po._id} className="pol-item">
                            <div className="pol-item-text">
                                <span className="pol-item-provider">{po.provider?.name}</span>
                                <span className="pol-item-meta">
                                    {po.items.map((it) => it.materialType === 'aviamento' ? it.aviamento?.name : it.cloth?.name).filter(Boolean).join(', ')}
                                </span>
                                {po.expectedArrival && (
                                    <span className="pol-item-meta">Previsão: {new Date(po.expectedArrival).toLocaleDateString('pt-BR')}</span>
                                )}
                            </div>
                            <span className="pol-item-value">R$ {po.totalValue.toFixed(2)}</span>
                            <span className={`pol-status-badge ${statusBadgeClass(po.status)}`}>{statusLabel(po.status)}</span>
                            {myPermissionEdit && po.status === 'aguardando' && (
                                <FiEdit2 className="shd-icon-row-edit" title="Editar Pedido de Compra" onClick={() => setEditItem(po)} />
                            )}
                        </div>
                    ))
                ) : (
                    <p className="pol-empty">Nenhum pedido de compra criado ainda para este pedido.</p>
                )}
            </div>

            <Modal
                modalStatus={!!editItem}
                changeStatus={() => setEditItem(null)}
                w={70}
                content={
                    editItem && (
                        <NewPurchaseOrder
                            order={order}
                            editingPO={editItem}
                            btCancelAction={() => setEditItem(null)}
                            handleOnSuccess={() => { setEditItem(null); getAll(); handleOnChange && handleOnChange() }}
                            myPermissionProviderCreate={myPermissionProviderCreate}
                        />
                    )
                }
            />
        </div>
    )
}

export default PurchaseOrderList
